'use strict';

var $ = require('jquery');

$(function() {
    $('.technical-toggle-button').click(function() {
        $(this).closest('.detail-wrapper').find('.technical-content').slideToggle(500);
        $(this).toggleClass('closed');
    });
});